import { AnnaError } from "@anna-money/anna-web-lib/utils";
import { makeAutoObservable } from "mobx";

import { SuburbAutocompleteResponseData } from "services/suburbSearch/suburbSearchTypes";
import { type SuburbSearchClient } from "./suburbSearchClient";

export class SuburbSearchStore {
  private readonly _suburbSearchClient: SuburbSearchClient;

  constructor(suburbSearchClient: SuburbSearchClient) {
    this._suburbSearchClient = suburbSearchClient;

    makeAutoObservable(this);
  }

  searchSuburbsByQuery = async (query: string, state: string): Promise<SuburbAutocompleteResponseData> => {
    try {
      return await this._suburbSearchClient.getSuburbSuggestions(query, state);
    } catch (e) {
      console.error(new AnnaError("Failed to load suburbs", { cause: e }));

      return new SuburbAutocompleteResponseData({ suburbs: [] });
    }
  };
}
